module.exports = __webpack_public_path__ + "static/media/checked_oval.a8eee8ff.svg";